import Button from 'components/Button';
import { AlertType } from 'components/alert/Alert';
import Form from 'components/formElements/Form';
import FormField from 'components/formElements/FormField';
import FormLabel from 'components/formElements/FormLabel';
import Password from 'components/formElements/Password';
import UseAlert from 'hooks/UseAlert';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { resetPassword } from 'services/User';

interface FormModel {
  password: string;
  passwordConfirm: string;
}

interface Props {
  token: string | undefined;
}

/**
 * Actual reset password component
 */
function ForgotPasswordReset({ token }: Props): JSX.Element {
  const [submitting, setSubmitting] = useState<boolean>(false);

  const navigate = useNavigate();
  const { alertElement: errorAlertElement, setMessage: setErrorMessage } = UseAlert(AlertType.Danger);

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormModel>();

  const passwordFormValue = watch('password');

  /**
   * Function that be called when submitting the form
   */
  const onSubmit = async ({ password }: FormModel) => {
    if (!token) return console.error('Invalid token');
    try {
      setSubmitting(true);
      await resetPassword(token, password);

      setErrorMessage(undefined);
      navigate('/login#password-reset-success');
    } catch (error) {
      setErrorMessage(error as string);
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return <></>;
  }

  return (
    <>
      {errorAlertElement}

      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormField>
          <FormLabel htmlFor='password'>New password</FormLabel>
          <Password
            onChangeScore={() => {
              // have noop FN shows the password indicator
              // setPasswordScore(score)
            }}
            newPassword={true}
            error={errors.password}
            {...register('password', {
              required: 'this field is required',
              validate: value => {
                if (value.length < 7) {
                  return 'Password should at least contains 6 chars';
                }
              },
            })}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor='name'>Password confirm</FormLabel>

          <Password
            newPassword={true}
            error={errors.passwordConfirm}
            {...register('passwordConfirm', {
              required: 'this field is required',
              validate: value => value === passwordFormValue || passwordFormValue === undefined || 'The passwords do not match',
            })}
          />
        </FormField>

        <div className='flex justify-center my-3 text-gray-700 dark:text-gray-200'>
          <Button htmlType='submit' type='primary' loading={submitting} fullWidth={true}>
            Reset your password
          </Button>
        </div>

        <div className='flex flex-col justify-center items-center gap-2 text-gray-700 dark:text-gray-200'>
          <Link to='/' className='text-sm mr-2'>
            return to login
          </Link>
        </div>
      </Form>
    </>
  );
}

export default ForgotPasswordReset;
